import { extractValues, omitValues } from '../../utils';
import Region from './region';

export const ALL_REGIONS = extractValues(Region);

export const TCJ_REGIONS = extractValues(Region.TCJ);

export const HAULING_CHARGE_REGIONS = [Region.MMPA, Region.PRAIRIE, ...TCJ_REGIONS, Region.UNC, Region.UDA, Region.CACIQUE];

export const SCHEDULING_REGIONS = omitValues(ALL_REGIONS, [Region.PEI, Region.NL, Region.RF]);

export const PROCESSED_FLUID_REGIONS = [Region.CDI, Region.PRAIRIE, Region.MMPA, Region.DEMO, Region.UDA, Region.IMP, Region.MINERVA];

export const POOLING_REGIONS = omitValues(ALL_REGIONS, [Region.PEI, Region.NL, Region.RF, Region.CDI, Region.UDA, Region.LEGACY]);

export const MANIFEST_REGIONS = omitValues(ALL_REGIONS, [Region.UDA, Region.NL, Region.PEI, Region.RF]);

export const ACCOUNTING_REGIONS = omitValues(ALL_REGIONS, [Region.NL, Region.PEI, Region.RF, Region.CACIQUE]);

export const MISC_SAMPLE_REGIONS = [Region.PRAIRIE, Region.MMPA, Region.UNC];

export const EMBEDDED_REPORT_REGIONS = omitValues(ALL_REGIONS, [Region.PEI, Region.NL, Region.RF]);

export const SILO_REGIONS = omitValues(ALL_REGIONS, [Region.PEI, Region.NL, Region.RF]);

export const MONTHLY_REPORT_REGIONS = [Region.NL, Region.PEI, Region.RF];

export const IN_PROGRESS_RAPID_TEST_REGIONS = [Region.UDA, Region.US_DEMO, Region.CA_DEMO];

export const NEW_SYSTEM_PERMISSION_REGIONS = omitValues(ALL_REGIONS, [Region.CDI, Region.LEGACY, Region.PRAIRIE, Region.UDA, Region.NL, Region.PEI, Region.RF]);

export const CONFIGURED_PROCESSOR_FORM_REGIONS = [Region.MMPA, Region.UNC, ...TCJ_REGIONS, Region.US_DEMO, Region.CA_DEMO, Region.DEMO];

export const DEFERRAL_PAY_STATEMENT_REGIONS = [Region.CDI, Region.UNC];

export const STATUS_REGIONS = [Region.CDI, Region.UDA, Region.LEGACY, Region.PEI, Region.NL, Region.RF];

export const MOBILE_RECEIVER_UI_REGIONS = [Region.UDA, Region.LEGACY, Region.PRAIRIE, Region.IMP, Region.MINERVA, Region.CDI];

export const MANIFEST_SELECT_DRIVER_REGIONS = omitValues(ALL_REGIONS, [Region.CDI, Region.PRAIRIE, Region.BONGARDS, ...TCJ_REGIONS]);

export const DASHBOARD_DEFAULT_WIDGET_REGIONS = omitValues(ALL_REGIONS, [Region.RF, Region.UDA, Region.CACIQUE]);

export const HELPFUL_LINKS_REGIONS = omitValues(ALL_REGIONS, [Region.PEI, Region.NL, Region.RF, Region.CDI, Region.LEGACY, Region.PRAIRIE, Region.CACIQUE, ...TCJ_REGIONS]);

export const BARCODE_PRINTING_REGIONS = [Region.PRAIRIE, Region.BONGARDS];

export const EQUITY_REGIONS = [Region.CDI, Region.PRAIRIE, Region.MMPA, Region.UNC, Region.BONGARDS];

export const PROCESSED_FLUIDS_BILL_TO_PROCESSOR_REGIONS = [Region.UDA, Region.IMP];

export const PROCESSED_FLUIDS_EXTENDED_TRACKING_REGIONS = [Region.UDA];

export const LOADOUT_COA_REGIONS = [Region.UDA];

export const PRODUCER_BUSINESS_PAY_REGIONS = [Region.BONGARDS, Region.IMP, Region.UDI];

export const PRODUCER_LIST_WITH_PICKUPS_REGIONS = [Region.PRAIRIE, Region.MMPA];

export const DETAILED_PAY_STATEMENT_REGIONS = omitValues(ALL_REGIONS, [Region.CDI, Region.LEGACY, Region.UDA, Region.PRAIRIE, Region.CACIQUE, Region.PSC, Region.IMP, ...TCJ_REGIONS]);

export const DOES_NOT_USE_CHECK_NUMBERS_REGIONS = [...TCJ_REGIONS, Region.UDA, Region.CDI, Region.LEGACY];

export const REGIONS_WITHOUT_FEDERAL_ORDER_DROPDOWN = [Region.LEGACY, Region.CDI, Region.UDA, Region.PSC, Region.IMP, Region.BONGARDS, Region.UDI];

// Regions that do not have a legacy nav system.
// Once we are fully migrated to NAV V2, this can be removed and ALL_REGIONS can be used instead.
// For now, in non native regions, we still allow users to switch back to the legacy nav.
export const NAV_V2_NATIVE_REGIONS = omitValues(ALL_REGIONS, [Region.CDI, Region.LEGACY, Region.PRAIRIE, Region.UDA, Region.MMPA, ...TCJ_REGIONS, Region.NL, Region.UNC, Region.CACIQUE, Region.BONGARDS, Region.PSC]);

// Note: We are using this regions list until all regions have moved to MooRules
export const SET_PAYMENT_DATE_PAYROLL_REGIONS = [Region.PSC, Region.TCJ.ERIE, Region.TCJ.WHITEEAGLE, Region.TCJ.GPDA, Region.IMP, Region.MINERVA, Region.UDI, Region.PLAINVIEW, Region.US_DEMO, Region.CA_DEMO, Region.DEMO];

export const USES_QUALITY_LAB_SLOTTING = [Region.LEGACY];

export const AGGREGATE_PRODUCER_BUSINESS_STATEMENT_REGIONS = [Region.IMP];

export const PREVENT_MANUAL_LAB_MATCHING = [Region.UDI];

export const StateMap = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
};

export const EQUITY_ROLE_BY_REGION = {
    [Region.CDI]: 'producer_business',
    [Region.PRAIRIE]: 'producer',
    [Region.MMPA]: 'producer',
    [Region.UNC]: 'producer',
    [Region.BONGARDS]: 'producer',
};
